import { columnsMap } from "./columns";
import { SearchAndSelectColumnId } from "./SearchAndSelectColumnId";
import { TableHead } from "@kaltura/mediaspace-shared-styled";
import { Checkbox, TableCell, TableSortHeaderCell } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { ChangeEvent } from "react";
import { StyledTableRow } from "./styled";

export interface MediaTableHeaderProps {
    /** Table column IDs list */
    columns: SearchAndSelectColumnId[];
    /** Current sorting value */
    sortBy: string;
    /** Default sorting value */
    defaultSortBy: string;
    onSortByChange: (sortBy: string) => void;

    selectionMode?: "single" | "multiple";

    allSelected?: boolean;

    onAllSelectChange?: (allSelected: boolean) => void;

    /** Whether actions column should be visible */
    showActionsColumn?: boolean;
}

/**
 * Header of the media table for Search and Select
 */
export const MediaTableHeader = ({
    columns,
    sortBy,
    defaultSortBy,
    onSortByChange,
    selectionMode = "single",
    allSelected = false,
    onAllSelectChange,
    showActionsColumn,
}: MediaTableHeaderProps) => {
    return (
        <TableHead>
            <StyledTableRow>
                {selectionMode === "multiple" && (
                    <TableCell className={"mediatablecell"} stickyColumn={true} aria-label={translate("Select all")}>
                        <Checkbox
                            checked={allSelected}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => onAllSelectChange?.(e.target.checked)}
                            slotProps={{
                                input: {
                                    "aria-label": translate("Select all"),
                                },
                            }}
                        />
                    </TableCell>
                )}
                {columns.map((columnId) => {
                    const { title, sort } = columnsMap[columnId];

                    if (!sort) {
                        return (
                            <TableCell key={columnId} className={"mediatablecell"}>
                                {title()}
                            </TableCell>
                        );
                    }

                    const { ascValue, descValue, defaultDesc = false } = sort;

                    const order = sortBy === ascValue ? "asc" : sortBy === descValue ? "desc" : false;

                    const handleClick = () => {
                        const defaultOrder = defaultDesc ? "desc" : "asc";
                        const secondaryOrder = defaultDesc ? "asc" : "desc";
                        const nextOrder =
                            order === false ? defaultOrder : order === defaultOrder ? secondaryOrder : false;
                        const nextValue =
                            nextOrder === "asc" ? ascValue : nextOrder === "desc" ? descValue : defaultSortBy;

                        onSortByChange(nextValue);
                    };

                    return (
                        <TableSortHeaderCell
                            key={columnId}
                            className={"mediatablecell"}
                            label={title()}
                            isActiveSort={order !== false}
                            order={order || "asc"}
                            columnFieldName={"not-used"}
                            onSortClick={handleClick}
                        />
                    );
                })}
                {showActionsColumn && <TableCell stickyColumn={true} aria-label={translate("Actions")}></TableCell>}
            </StyledTableRow>
        </TableHead>
    );
};
